var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcEquipmentMaterial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 18.8133H27.96V17.6267C27.96 16.6933 27.2133 15.9467 26.3067 15.9467H18.6267C17.72 15.9467 16.9733 16.7067 16.9733 17.6267V18.8133H15.9333C14.28 18.8133 12.9333 20.16 12.9333 21.8133V29C12.9333 30.6533 14.28 32 15.9333 32H28.9867C30.64 32 31.9867 30.6533 31.9867 29V21.8133C31.9867 20.16 30.64 18.8133 28.9867 18.8133H29ZM18.9867 17.9467H25.96V18.8133H18.9867V17.9467ZM15.9467 20.8133H29C29.5467 20.8133 30 21.2667 30 21.8133V22.7333H14.9467V21.8133C14.9467 21.2667 15.4 20.8133 15.9467 20.8133ZM21.3467 24.7467H23.5867V26.0267H21.3467V24.7467ZM15.9467 30C15.4 30 14.9467 29.5467 14.9467 29V24.7467H19.36V28.0267H25.6V24.7467H30.0133V29C30.0133 29.5467 29.56 30 29.0133 30H15.9467Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 5H22V4C22 2.89333 21.1067 2 20 2H12C10.8933 2 10 2.89333 10 4V5H7C5.89333 5 5 5.89333 5 7V28C5 29.1067 5.89333 30 7 30H10.9467V28H7V7H10V10H22V7H25V13.9467H27V7C27 5.89333 26.1067 5 25 5ZM20 8H12V4H20V8Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEquipmentMaterial);
export default __webpack_public_path__ + "static/media/ic-equipment-material.711a445cebdfc6c1458939deed1d5bc2.svg";
export { ForwardRef as ReactComponent };